var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"atom-info-price"},[_c('AtomsCommonAtomIcon',{attrs:{"icon":_vm.icon}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }